module.exports = __webpack_public_path__ + "img/la8mediterraneo.31509213.jpg";